// extracted by mini-css-extract-plugin
export default {"notPageFoundNoAuth":"NotPageFound_notPageFoundNoAuth__pChjN"};